<template>
  <div class="sourceHeader">
    <div class="sourceHeader__menu" @click="goToHomePage()">
      <svgicon
        name="menu"
        color="var(--primary-yellow)"
        height="2.5rem"
        width="2.5rem"
      />
    </div>
    <div class="sourceHeader__caption">
      <h1 class="sourceHeader__caption--title">{{ title }}</h1>
      <p class="sourceHeader__caption--year">Data related to {{ year }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "HeaderSource",
  props: {
    title: { type: String, required: false },
    year: { type: String, required: false },
  },
  computed: {
    ...mapGetters({
      lastUpdated: "data/getLastUpdated",
    }),
  },
  methods: {
    goToHomePage() {
      this.toggleMenu(true);
      this.$router.push("/");
    },
    ...mapActions({
      setMainSource: "ui/setMainSource",
      toggleMenu: "ui/toggleMenu",
    }),
  },
};
</script>

<style lang="scss" scoped>
.sourceHeader {
  position: fixed;
  height: 9.21vh;
  z-index: 11;
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: var(--source-color-main);
  border-bottom: $white-border;

  &__menu {
    height: 100%;
    width: $header-width-mobile;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: $white-border;
  }

  &__caption {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    color: $ui-white;
    @include link-L;
    padding-left: 3.2vw;

    &--year {
      color: $white-08;
      margin-top: toRem(2);
      @include number-XS;
    }
  }
}

.tablet {
  .sourceHeader {
    height: 5.72vh;

    &__menu {
      width: 9vw;
    }

    &__caption {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 toRem(39) 0 toRem(30);
      width: 100%;
    }
  }
}
</style>
